/**
 * Converts a svg to a data URI like: data:image/svg+xml;charset=UTF-8...
 * @param svg The svg content
 */
export const svgToDataUri = (svg: string) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
